import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { myLocalStorage } from "../../../components/StorageHelper";
import { NGROK } from "../../../APIs";
import axios from "axios";
import useUserStore from "../../../services/userStore";
import CloudEntityAnalytics from "../../../components/v2components/CloudAnalytics/CloudEntityAnalytics";

const GcpUserInfo = () => {
  const location = useLocation();
  const { user: initialUser } = location.state || { user: {} };
  const latestTenant = myLocalStorage.getItem("latestTenant")?.tenantName;
  const [, setSelectedTab] = useState("analytics");
  const [user] = useState(initialUser);
  const [roleDefinitions] = useState(
    initialUser?.roles || [],
  );
  const { role } = useUserStore((state) => state.user);
  let { projectId, syncedAt, email } = user;
  const [, setProjectIdList] = useState([]);
  const latestprojectId = myLocalStorage.getItem("gcpSelectedProjectId");
  const [project, setProjectId] = useState("");




  const fetchUserProjectList = async () => {
    try {
      const response = await axios.get(
        `${NGROK}/api/gcp/get-config-user-projects?tenantName=${latestTenant}&gcpAccountEmail=${email}`,
      );

      const projects = response?.data || [];
      setProjectIdList(projects);

      if (projects.length > 0) {
        let latest = null;

        try {
          latest =
            typeof latestprojectId === "string"
              ? JSON.parse(latestprojectId)
              : latestprojectId;
        } catch (e) {
          latest = null;
        }

        const match = latest ? projects.find((item) => item === latest) : null;

        const selected = match || projects[0];
        myLocalStorage.setItem("gcpSelectedProjectId", selected);

        setProjectId(selected);
      } else {
      }
    } catch (error) {
      console.error("Failed to fetch project for user:", error);
    }
  };
  useEffect(() => {
    if (role === "TENANT_USER") {
      fetchUserProjectList();
    }
    if (role !== "TENANT_USER") setSelectedTab("analytics");
    else setSelectedTab("resources");
  }, [role]);
  useEffect(() => {
    if (role === "TENANT_USER") {
      setProjectId(latestprojectId);
    }
  }, [latestprojectId, project]);


  return <CloudEntityAnalytics cloudProvider={"gcp"} email={email} entityId={email} entityType="user" projectId={projectId} roles={roleDefinitions} syncedAt={syncedAt} entityName={projectId} />
};

export default GcpUserInfo;
